(function() {
  'use strict';

  angular.module('ringbaPortal').directive('setThemeToDom', setThemeToDom);
  angular.module('ringbaPortal').controller('SetThemeToDomController', SetThemeToDomController);

  function SetThemeToDomController() {

  }

  function setThemeToDom(
    userSettingsService,
    whitelabelEditorService,
    whitelabelManager,
    $timeout
  ) {
    'ngInject';

    const directive = {
      restrict: 'E',
      require: 'setThemeToDom',
      scope: {
        currentTheme: '<',
        isLightTheme: '<',
        isSiteFriendlyNamed: '<',
        isPreviewMode: '<'
      },
      link: link,
      controller: 'SetThemeToDomController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

    function link(scope, element, attrs, $setThemeToDomController) {
      const specificValueChangeHandlers = {};
      let bodyElement = $('body');
      let isUserSettingThemeLight;

      $setThemeToDomController.$onChanges = onChanges;

      specificValueChangeHandlers[whitelabelEditorService.getBrandLogoCssVariable()] = setBrandLogo;
      specificValueChangeHandlers[whitelabelEditorService.getBrandFaviconCssVariable()] = setBrandFavicon;
      specificValueChangeHandlers['--component-login__welcome-message'] = _setNonColorValue.bind(null, '--component-login__welcome-message');
      specificValueChangeHandlers['--component-login__welcome-sub-message'] = _setNonColorValue.bind(null, '--component-login__welcome-sub-message');
      specificValueChangeHandlers['--component-login__right-footer-message'] = _setNonColorValue.bind(null, '--component-login__right-footer-message');
      specificValueChangeHandlers['--component-join-invite__welcome-message'] = _setNonColorValue.bind(null, '--component-join-invite__welcome-message');
      specificValueChangeHandlers['--component-publisher-registration__welcome-message'] = _setNonColorValue.bind(null, '--component-publisher-registration__welcome-message');
      specificValueChangeHandlers['--component-buyer-registration__welcome-message'] = _setNonColorValue.bind(null, '--component-buyer-registration__welcome-message');
      specificValueChangeHandlers['--brand-name'] = _setNonColorValue.bind(null, '--brand-name');

      _getUserSettings();
      if ($setThemeToDomController.isPreviewMode) {
        _setPreview();
      }

      function _setPreview() {
        resetThemeToDefaultValues($setThemeToDomController.currentTheme);
        _setVariablesFromTheme($setThemeToDomController.currentTheme);
        _handleLightDarkThemeChange();
      }

      function onChanges(changesObj) {
        if (changesObj.currentTheme) {
          resetThemeToDefaultValues(changesObj.currentTheme.previousValue);
          _setVariablesFromTheme($setThemeToDomController.currentTheme);
        }
        if (changesObj.isLightTheme) {
          _handleLightDarkThemeChange();
        }
      }

      function _handleLightDarkThemeChange() {
        if ($setThemeToDomController.isLightTheme) {
          bodyElement.addClass('theme--light');
          bodyElement.removeClass('theme--dark');
        } else if (typeof $setThemeToDomController.isLightTheme !== 'undefined') {
          bodyElement.removeClass('theme--light');
          bodyElement.addClass('theme--dark');
        }
      }

      function setBrandLogo(base64) {
        const finalImage = base64;
        bodyElement[0].style.setProperty(whitelabelEditorService.getBrandLogoCssVariable(), finalImage || null);
      }

      function setBrandFavicon(base64) {
        $timeout(function(){
          whitelabelManager.updateFavicon(base64);
        }, 0);
      }

      function resetThemeToDefaultValues(theme) {
        if (theme) {
          changeCSSVariables([whitelabelEditorService.getBrandLogoCssVariable()], null);
          changeCSSVariables([whitelabelEditorService.getBrandFaviconCssVariable()], null);
          _.forEach(theme.default, function(value, cssVar) {
            bodyElement[0].style.setProperty(cssVar, null);
          });
        }
      }

      function _setVariablesFromTheme(theme) {
        if (theme) {
          _.forEach(theme.default, function(value, cssVar) {
            if (specificValueChangeHandlers[cssVar]) {
              specificValueChangeHandlers[cssVar](value);
            } else {
              changeCSSVariables([cssVar], value);
            }
          });
        }
      }

      function changeCSSVariables(cssVariables, value, isTextInput) {
        if (value && value.indexOf('#') > -1) {
          value = value.trim().replace('#', '');
        }
        _.forEach(cssVariables, function(variable) {
          bodyElement[0].style.setProperty(variable, value && !isTextInput ? '#' + value : value);
        });
      }

      function _setNonColorValue(cssVar, value) {
        value = value.replace(/["]/g, '');
        changeCSSVariables([cssVar], '"' + value + '"', true);
      }

      scope.$on('$destroy', function() {
        if ($setThemeToDomController.isSiteFriendlyNamed) {
          if (whitelabelEditorService.checkThemeIsLight($setThemeToDomController.currentTheme) && bodyElement.hasClass('theme--dark')) {
            bodyElement.removeClass('theme--dark');
          } else if (!whitelabelEditorService.checkThemeIsLight($setThemeToDomController.currentTheme)) {
            bodyElement.addClass('theme--dark');
          }
        } else {
          resetThemeToDefaultValues($setThemeToDomController.currentTheme);
          _resetBodyClass();
        }
        bodyElement = null;
      });

      function _resetBodyClass() {
        bodyElement.removeClass('theme--dark');
        if (isUserSettingThemeLight) {
          bodyElement.addClass('theme--light');
        } else {
          bodyElement.removeClass('theme--light');
        }
      }

      function _getUserSettings() {
        userSettingsService.getUserSettings()
          .then(function(userSettings) {
            isUserSettingThemeLight = userSettings.isLightTheme;
          });
      }

    }

  }

})();
